import React, { FC, useEffect } from 'react'

import CrewForm from '../molecules/CrewForm';

import MainLayout from '../../Layouts/MainLayout';
import { useAuth } from '../../../context/AuthContext';
//Crew-form
const CrewFormPage: FC = () => {
 
  return (
    <>
     <MainLayout>
      
       <CrewForm/>
     </MainLayout>
    </>
  )
}
export default CrewFormPage;